// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get("language");
const isWebView = navigator.userAgent.includes("EDPFlutterApp") || localStorage.getItem("webView") === "true";

if (lang && isWebView) {
  if (window.location.pathname === "/" || window.location.pathname === "/map/") {    
    localStorage.setItem('i18nextLng', lang);
    localStorage.setItem('i18nextLngNotLandingPage', lang);
  } else {    
    localStorage.setItem('i18nextLngNotLandingPage', lang);
    localStorage.setItem('i18nextLng', lang);
  }
}
i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: (window.location.pathname === "/" || window.location.pathname === "/map/")
      ? localStorage.getItem("i18nextLng") || 'en'
      : localStorage.getItem("i18nextLngNotLandingPage") || localStorage.getItem("i18nextLng") || 'en',

    fallbackLng: 'en',
    
    debug: true,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      loadPath: `${process.env.REACT_APP_BASE_URL}locales/{{lng}}.json`,
    },
    detection: {
      order: ['queryString', 'cookie'],
      cache: ['cookie'],
    },
  });

export default i18n;
